'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ModalNav = require('./ModalNav');

var _ModalNav2 = _interopRequireDefault(_ModalNav);

var _UserRow = require('../../shared/UserRow');

var _UserRow2 = _interopRequireDefault(_UserRow);

var _Uniform = require('../../Uniform');

var _propTypes = require('../../../shared/prop-types');

var spt = _interopRequireWildcard(_propTypes);

var _reactRedux = require('react-redux');

var _logValues = require('../../../shared/logging/log-values');

var _hudlBase = require('hudl-base');

var _actionCreators = require('../../../store/actions/action-creators');

var _pagescrollHelper = require('../../../utils/pagescroll-helper');

require('./_reactiondetailsmodal.scss');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function mapStateToProps(state, ownProps) {
  var _state$reaction = state.reaction,
      contentReactions = _state$reaction.contentReactions,
      contentReactionDetails = _state$reaction.contentReactionDetails;
  var _ownProps$communityCo = ownProps.communityContentIdObject,
      communityContentType = _ownProps$communityCo.type,
      communityContentRelatedId = _ownProps$communityCo.relatedId;


  var communityContentIdKey = communityContentType + '-' + communityContentRelatedId;

  var _contentReactions$com = contentReactions[communityContentIdKey],
      currentUserReactions = _contentReactions$com.currentUserReactions,
      existingReactions = _contentReactions$com.existingReactions,
      reactions = _contentReactions$com.reactions;

  var _ref = contentReactionDetails[communityContentIdKey] || {},
      _ref$reactionDetails = _ref.reactionDetails,
      reactionDetails = _ref$reactionDetails === undefined ? {} : _ref$reactionDetails;

  var currentUser = state.userDetails.currentUser;
  var currentUserDetails = currentUser.details;


  return {
    currentUserDetails: currentUserDetails,
    currentUserReactions: currentUserReactions,
    existingReactions: existingReactions,
    reactionDetails: reactionDetails,
    reactions: reactions
  };
}

// Only authenticated users can view reaction details for now.

var ReactionDetailsModal = function (_Component) {
  _inherits(ReactionDetailsModal, _Component);

  function ReactionDetailsModal(props) {
    _classCallCheck(this, ReactionDetailsModal);

    var _this = _possibleConstructorReturn(this, (ReactionDetailsModal.__proto__ || Object.getPrototypeOf(ReactionDetailsModal)).call(this, props));

    _this.onClickProfile = function () {
      var logData = _this.props.logData;

      // UsageLogEvent converts keys to PascalCase

      var usageLogData = {
        func: 'Click',
        op: 'Profile'
      };

      if (logData[_logValues.ORIGIN_KEY]) {
        usageLogData.origin = logData[_logValues.ORIGIN_KEY];
      }

      /* eslint-disable no-new */
      new _hudlBase.UsageLogEvent({
        logger: 'Feed',
        logOnUnload: true,
        data: usageLogData
      });
      /* eslint-enable no-new */
    };

    _this.onClickReaction = function (e, reaction) {
      e.preventDefault();
      _this.selectReaction(reaction);
    };

    _this.onScrollContent = function () {
      var dispatch = _this.props.dispatch;
      var selectedReaction = _this.state.selectedReaction;


      if (!selectedReaction) {
        return;
      }

      var reactionUsersWrapper = _this.refs.reactionUsersWrapper;
      var scrollTop = reactionUsersWrapper.scrollTop;
      var maxScroll = reactionUsersWrapper.scrollHeight - reactionUsersWrapper.clientHeight;
      var scrollPercentage = scrollTop / maxScroll;

      if (scrollPercentage > 0.80) {
        var communityContentIdObject = _this.props.communityContentIdObject;
        var communityContentType = communityContentIdObject.type,
            communityContentRelatedId = communityContentIdObject.relatedId;


        dispatch((0, _actionCreators.fetchReactionUsersIfNeeded)(communityContentType, communityContentRelatedId, selectedReaction));
      }
    };

    _this.state = {
      selectedReaction: null
    };
    return _this;
  }

  _createClass(ReactionDetailsModal, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.showModal) {
        this.selectedDefaultReaction(this.props.existingReactions);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var showModal = nextProps.showModal;


      if (!showModal) {
        return;
      }

      var selectedReaction = this.state.selectedReaction;
      var reactions = nextProps.reactions;

      var _ref2 = reactions[selectedReaction] || {},
          _ref2$count = _ref2.count,
          count = _ref2$count === undefined ? 0 : _ref2$count;

      var selectedReactionCount = count;

      if (selectedReaction && selectedReactionCount > 0) {
        return;
      }

      var existingReactions = nextProps.existingReactions;

      this.selectDefaultReaction(existingReactions);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props.showModal || nextProps.showModal;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.showModal && !this.props.showModal) {
        // Defer this to give the modal time to close. This helps prevent
        // jumpiness in Safari.
        setTimeout(_pagescrollHelper.enablePageScroll, 20);
      }
    }
  }, {
    key: 'selectReaction',
    value: function selectReaction(reaction) {
      this.setState({ selectedReaction: reaction });

      var _props = this.props,
          reactionDetails = _props.reactionDetails,
          dispatch = _props.dispatch;

      var _ref3 = reactionDetails[reaction] || {},
          _ref3$users = _ref3.users,
          users = _ref3$users === undefined ? [] : _ref3$users;

      if (!users.length) {
        var communityContentIdObject = this.props.communityContentIdObject;
        var communityContentType = communityContentIdObject.type,
            communityContentRelatedId = communityContentIdObject.relatedId;

        dispatch((0, _actionCreators.fetchReactionUsersIfNeeded)(communityContentType, communityContentRelatedId, reaction));
      }
    }
  }, {
    key: 'selectDefaultReaction',
    value: function selectDefaultReaction(existingReactions) {
      var nextSelectedReaction = null;
      if (existingReactions.length) {
        nextSelectedReaction = existingReactions[0];
      }

      this.selectReaction(nextSelectedReaction);
    }
  }, {
    key: 'getReactionNavComponent',
    value: function getReactionNavComponent() {
      var existingReactions = this.props.existingReactions;
      var selectedReaction = this.state.selectedReaction;


      return _react2.default.createElement(_ModalNav2.default, {
        onClickReaction: this.onClickReaction,
        existingReactions: existingReactions,
        selectedReaction: selectedReaction
      });
    }
  }, {
    key: 'getReactionUsersComponent',
    value: function getReactionUsersComponent() {
      var _this2 = this;

      var selectedReaction = this.state.selectedReaction;
      var _props2 = this.props,
          currentUser = _props2.currentUserDetails,
          currentUserReactions = _props2.currentUserReactions,
          logData = _props2.logData,
          reactionDetails = _props2.reactionDetails;


      var currentUserHasReacted = currentUserReactions.includes(selectedReaction);

      var _ref4 = currentUser.feedUserId || {},
          currentUserRelatedId = _ref4.relatedId,
          currentUserType = _ref4.type;

      var showAnyFollow = !!currentUserRelatedId;

      var _ref5 = reactionDetails[selectedReaction] || {},
          _ref5$isFetching = _ref5.isFetching,
          isFetching = _ref5$isFetching === undefined ? false : _ref5$isFetching;

      var _ref6 = reactionDetails[selectedReaction] || {},
          _ref6$users = _ref6.users,
          users = _ref6$users === undefined ? [] : _ref6$users;

      if (currentUserHasReacted) {
        users = users.slice();
        users.unshift(currentUser);
      }

      var userList = users.map(function (user) {
        return _react2.default.createElement(
          'li',
          { key: user.userId },
          _react2.default.createElement(_UserRow2.default, {
            logData: logData,
            onClickProfile: _this2.onClickProfile,
            showFollowButton: showAnyFollow && !(user.feedUserId.type === currentUserType && user.feedUserId.relatedId === currentUserRelatedId),
            user: user
          })
        );
      });

      return _react2.default.createElement(
        'div',
        {
          className: 'feed-modal-user-list-wrapper',
          onScroll: this.onScrollContent,
          ref: 'reactionUsersWrapper'
        },
        _react2.default.createElement(
          'ul',
          { className: 'feed-modal-user-list' },
          userList
        ),
        isFetching ? _react2.default.createElement(
          'div',
          { className: 'infinite-css-spinner-wrapper' + (userList && userList.length ? '' : ' full-height') },
          _react2.default.createElement(_Uniform.Spinner, { size: 'medium' })
        ) : null
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Uniform.Modal,
        {
          title: 'People Who Reacted',
          isOpen: this.props.showModal,
          className: 'feed-reaction-modal',
          onAfterOpen: _pagescrollHelper.disablePageScroll,
          onClose: this.props.onCloseModal
        },
        this.getReactionNavComponent(),
        _react2.default.createElement(
          'div',
          { className: 'feed-modal-content' },
          this.getReactionUsersComponent()
        )
      );
    }
  }]);

  return ReactionDetailsModal;
}(_react.Component);

ReactionDetailsModal.propTypes = {
  communityContentIdObject: spt.CommunityContentId.isRequired,
  currentUserDetails: spt.ReactionUserDetails.isRequired,
  currentUserReactions: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
  existingReactions: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
  logData: _react.PropTypes.object.isRequired,
  onCloseModal: _react.PropTypes.func.isRequired,
  reactions: _react.PropTypes.objectOf(_react.PropTypes.shape({
    count: _react.PropTypes.number.isRequired,
    mostRecentUsers: _react.PropTypes.array
  })).isRequired,
  reactionDetails: _react.PropTypes.objectOf(_react.PropTypes.shape({
    isError: _react.PropTypes.bool.isRequired,
    isFetching: _react.PropTypes.bool.isRequired,
    nextReactionDate: _react.PropTypes.string,
    users: _react.PropTypes.arrayOf(spt.ReactionUserDetails)
  })).isRequired,
  showModal: _react.PropTypes.bool.isRequired,
  dispatch: _react.PropTypes.func.isRequired
};
ReactionDetailsModal.defaultProps = {
  logData: {}
};
exports.default = (0, _reactRedux.connect)(mapStateToProps)(ReactionDetailsModal);